import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout-wrapper" }
const _hoisted_2 = { class: "gfu-grid gfu-grid--gutter _flex _jc-c" }
const _hoisted_3 = { class: "gfu-grid__cell gfu-1of3--l gfu-4of6--m gfu-1of1" }
const _hoisted_4 = {
  class: "gfu-heading gfu-heading--soft gfu-box__title gfu-box__title--success",
  "data-qa": "link-sent-message"
}
const _hoisted_5 = { class: "_tac" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_box, {
          thick: true,
          class: "_mt-6 _mb-3"
        }, {
          default: _withCtx(() => [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.Resources.ResetPassword.LinkSentHeader), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString(_ctx.Resources.ResetPassword.LinkSentParagraph), 1 /* TEXT */),
              _createElementVNode("p", {
                innerHTML: _ctx.Resources.ResetPassword.LinkSentFollowInstructionParagraph
              }, null, 8 /* PROPS */, _hoisted_6)
            ])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ])
  ]))
}